import T from "utils/T";

const GLOCOSE_COLUMNS = [
  T('전체'),
  T('월'),
  T('화'),
  T('수'),
  T('목'),
  T('금'),
  T('토'),
  T('일'),
  T('주중'),
  T('주말'),
  T('새벽'),
  T('오전'),
  T('오후'),
  T('저녁'),
];

export default GLOCOSE_COLUMNS;